import type { DownloadFile } from "../../content/downloads";
import { formatSize } from "../../content/downloads";

interface DownloadButtonProps {
  file: DownloadFile;
  variant: "primary" | "secondary";
}

export function DownloadButton({ file, variant }: DownloadButtonProps) {
  const baseClasses =
    "group flex items-center justify-between w-full px-4 py-3 rounded-lg border transition-all duration-200";

  const variantClasses = {
    primary:
      "bg-blue-600 border-blue-500 hover:bg-blue-500 text-white shadow-lg shadow-blue-900/20",
    secondary:
      "bg-dark-card border-dark-border hover:bg-dark-hover hover:border-warm-700 text-warm-100",
  };

  return (
    <a href={file.url} className={`${baseClasses} ${variantClasses[variant]}`} download>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-medium truncate">{file.label}</span>
          {file.sublabel && (
            <span className="text-xs opacity-75 bg-white/10 px-2 py-0.5 rounded">
              {file.sublabel}
            </span>
          )}
        </div>
        <span className={`text-xs ${variant === "primary" ? "text-blue-200" : "text-warm-500"}`}>
          {formatSize(file.size)}
        </span>
      </div>
      <svg
        className="w-5 h-5 ml-3 flex-shrink-0 opacity-70 group-hover:opacity-100 group-hover:translate-y-0.5 transition-all"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
        />
      </svg>
    </a>
  );
}
